<template>
  <div class="h-full">
    <div class="container-sm text-black-light-5 mdsm:hidden">
      <p>
        Type a destination in the search box above or select from the list below
      </p>
    </div>

    <div v-if="loading">
      <loading-item></loading-item>
    </div>

    <!-- eslint-disable -->
    <div v-else class="featured-search-wrapper container-sm py-6 mdsm:p-3">
      <div
        v-if="isAreaVisible(level1)"
        class="area-group mb-8"
        v-for="(level1, index) in featuredSearches"
        :key="index"
      >
        <p
          class="font-medium fs-20 mb-2 mdsm:px-3 mdsm:py-1 mdsm:text-base mdsm:mb-1 mdsm:bg-black-light-1"
          :class="{ hidden: !isAreaVisible(level1) }"
        >
          {{ level1.title }}
        </p>

        <ul class="featured-search-item-group-lvl1 mdsm:px-3">
          <li v-for="(level2, index2) in level1.children" :key="index2">
            <p
              class="font-medium mb-2 cursor-pointer mdsm:py-1"
              :class="{ hidden: !isCountryVisible(level2) }"
              @click="handleSelectItem(level2)"
            >
              {{ level2.title }}
            </p>

            <ul
              class="featured-search-item-group-lvl2"
              v-if="['resort', 'liveaboard'].includes(searchType)"
            >
              <li
                v-for="(level3, index3) in level2.children"
                :key="index3"
                class="pl-4 mb-2 featured-search-item cursor-pointer"
                :class="{ hidden: !isDestinationVisible(level3) }"
                @click="handleSelectItem(level3)"
              >
                {{ level3.title }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingItem from "./LoadingItem";
import get from "lodash/get";
import FeaturedSearchMixin from "../mixins/FeaturedSearchMixin";

export default {
  mixins: [FeaturedSearchMixin],
  components: {
    LoadingItem,
  },
  props: {
    searchType: {
      type: String,
      required: true,
    },
    featuredSearches: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    featuredSearchStats() {
      return get(window.topNavStore, ["state", "featuredSearchStats"], null);
    },
  },
  methods: {
    handleSelectItem(which) {
      this.$emit("change", which);
    },
  },
};
</script>

<style scoped>
.featured-search-wrapper {
  column-count: 4;
  width: 100%;
}

.area-group {
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid;
}

@media (max-width: 992px) {
  .featured-search-wrapper {
    max-height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }
}
</style>
